(() => {
  const updateCount = (input) => {
    const wrapper = input.closest('.dm-line-item-property');
    const current = wrapper?.querySelector('[data-character-count-current]');

    if (current) current.textContent = input.value.length;
  };

  document.querySelectorAll('[data-character-count-input]').forEach((input) => {
    updateCount(input);
    input.addEventListener('input', () => updateCount(input));
  });
})();
